import { createFileRoute } from "@tanstack/react-router";

import { MorrowAgentsListPage } from "../components/workspace/MorrowAgentsListPage";

export const Route = createFileRoute("/agents/")({
  component: MorrowAgentsListPage,
});
